var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-32p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_21137",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.330078,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_21137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "support_agent",
    d: "M14.9961 28V25.7778H26.1072V15.8667C26.1072 13.1676 25.1586 10.878 23.2612 8.99793C21.3638 7.11782 19.0532 6.17777 16.3294 6.17777C13.6056 6.17777 11.295 7.11782 9.39766 8.99793C7.5003 10.878 6.55163 13.1676 6.55163 15.8667V24H5.66276C4.92943 24 4.30165 23.7389 3.77943 23.2167C3.2572 22.6944 2.99609 22.0667 2.99609 21.3333V18.6667C2.99609 18.2 3.11276 17.7611 3.34609 17.35C3.57943 16.9389 3.9072 16.6111 4.32943 16.3667L4.42943 14.6C4.6072 13.0889 5.04609 11.6889 5.74609 10.4C6.44609 9.11111 7.32387 7.98889 8.37943 7.03333C9.43498 6.07778 10.6461 5.33333 12.0128 4.8C13.3794 4.26667 14.8183 4 16.3294 4C17.8405 4 19.2739 4.26667 20.6294 4.8C21.985 5.33333 23.1961 6.07222 24.2628 7.01667C25.3294 7.96111 26.2072 9.07778 26.8961 10.3667C27.585 11.6556 28.0294 13.0556 28.2294 14.5667L28.3294 16.3C28.7516 16.5 29.0794 16.8 29.3128 17.2C29.5461 17.6 29.6628 18.0222 29.6628 18.4667V21.5333C29.6628 21.9778 29.5461 22.4 29.3128 22.8C29.0794 23.2 28.7516 23.5 28.3294 23.7V25.7778C28.3294 26.3889 28.1118 26.9121 27.6767 27.3472C27.2415 27.7824 26.7183 28 26.1072 28H14.9961ZM12.3255 18.4444C12.0096 18.4444 11.7461 18.3376 11.535 18.1239C11.3239 17.9102 11.2183 17.6453 11.2183 17.3294C11.2183 17.0135 11.3252 16.75 11.5389 16.5389C11.7526 16.3278 12.0174 16.2222 12.3333 16.2222C12.6492 16.2222 12.9128 16.3291 13.1239 16.5428C13.335 16.7565 13.4405 17.0213 13.4405 17.3372C13.4405 17.6531 13.3337 17.9167 13.12 18.1278C12.9062 18.3389 12.6414 18.4444 12.3255 18.4444ZM20.3255 18.4444C20.0096 18.4444 19.7461 18.3376 19.535 18.1239C19.3239 17.9102 19.2183 17.6453 19.2183 17.3294C19.2183 17.0135 19.3252 16.75 19.5389 16.5389C19.7526 16.3278 20.0174 16.2222 20.3333 16.2222C20.6492 16.2222 20.9128 16.3291 21.1239 16.5428C21.335 16.7565 21.4405 17.0213 21.4405 17.3372C21.4405 17.6531 21.3337 17.9167 21.12 18.1278C20.9062 18.3389 20.6414 18.4444 20.3255 18.4444ZM8.36276 16.6C8.2072 14.2444 8.91832 12.2222 10.4961 10.5333C12.0739 8.84444 14.0405 8 16.3961 8C18.3442 8 20.0424 8.63519 21.4905 9.90557C22.9387 11.1759 23.8183 12.7741 24.1294 14.7C22.1368 14.6778 20.3127 14.1259 18.6572 13.0444C17.0016 11.963 15.7236 10.5259 14.8232 8.73333C14.4718 10.5111 13.7239 12.0944 12.5794 13.4833C11.435 14.8722 10.0294 15.9111 8.36276 16.6Z",
    fill: "#21438B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportAgent);
export default __webpack_public_path__ + "static/media/support_agent.e9abcad9e55278734c1eb1cbfcba333c.svg";
export { ForwardRef as ReactComponent };